import {BrowserRouter, Route, Routes} from "react-router-dom";

import App from "./components/App";
import Loadable from "react-loadable";
import Loading from "./components/helpers/loading";
import React from "react";
import {createRoot} from "react-dom/client";
import Root from "./Root";
import withTracker from "./withTracker";

// /* Lazy Loaded Components */
const NotFound = Loadable({loader: () => import("./components/NotFound"), loading: () => <Loading/>});
const Location = Loadable({loader: () => import("./components/Mobile/Location"), loading: () => <Loading/>});
const Login = Loadable({loader: () => import("./components/Mobile/Auth"), loading: () => <Loading/>});
const Register = Loadable({loader: () => import("./components/Mobile/Auth/Register"), loading: () => <Loading/>});
const CartPage = Loadable({loader: () => import("./components/Mobile/Cart"), loading: () => <Loading/>});
const Account = Loadable({loader: () => import("./components/Mobile/Account"), loading: () => <Loading/>});


const Explore = Loadable({loader: () => import("./components/Mobile/Explore"), loading: () => <Loading/>});
const Contests = Loadable({loader: () => import("./components/Mobile/Contests"), loading: () => <Loading/>});
const Events = Loadable({loader: () => import("./components/Mobile/Events"), loading: () => <Loading/>});
const Event = Loadable({loader: () => import("./components/Mobile/Event"), loading: () => <Loading/>});
const Addresses = Loadable({loader: () => import("./components/Mobile/Account/Addresses"), loading: () => <Loading/>});
const Checkout = Loadable({loader: () => import("./components/Mobile/Checkout"), loading: () => <Loading/>});
const RunningOrder = Loadable({loader: () => import("./components/Mobile/RunningOrder"), loading: () => <Loading/>});
const Orders = Loadable({loader: () => import("./components/Mobile/Account/Orders"), loading: () => <Loading/>});
const WalletPage = Loadable({loader: () => import("./components/Mobile/Account/Wallet"), loading: () => <Loading/>});
const Delivery = Loadable({loader: () => import("./components/Delivery"), loading: () => <Loading/>});
const DeliveryLogin = Loadable({loader: () => import("./components/Delivery/Login"), loading: () => <Loading/>});
const DeliveryOrders = Loadable({loader: () => import("./components/Delivery/Orders"), loading: () => <Loading/>});
const ViewOrder = Loadable({loader: () => import("./components/Delivery/ViewOrder"), loading: () => <Loading/>});
const GeoLocationPage = Loadable({
    loader: () => import("./components/Mobile/GeoLocationPage"),
    loading: () => <Loading/>
});
const ItemsParent = Loadable({
    loader: () => import("./components/Mobile/Items/ItemsParent"),
    loading: () => <Loading/>
});
const SingleItemParent = Loadable({
    loader: () => import("./components/Mobile/Items/SingleItemParent"),
    loading: () => <Loading/>
});
const SinglePage = Loadable({loader: () => import("./components/SinglePage"), loading: () => <Loading/>});
const ForgotPassword = Loadable({
    loader: () => import("./components/Mobile/Auth/ForgotPassword"),
    loading: () => <Loading/>
});
const RestaurantListOnCategory = Loadable({
    loader: () => import("./components/Mobile/Home/RestaurantListOnCategory"),
    loading: () => <Loading/>
});
const RatingAndReview = Loadable({
    loader: () => import("./components/Mobile/Account/Orders/RatingAndReview"),
    loading: () => <Loading/>
});
const ViewStoreReviews = Loadable({
    loader: () => import("./components/Mobile/StoreReviews"),
    loading: () => <Loading/>
});
const Alerts = Loadable({loader: () => import("./components/Mobile/Alerts"), loading: () => <Loading/>});
const FavoriteRestaurantList = Loadable({
    loader: () => import("./components/Mobile/Home/FavoriteRestaurants"),
    loading: () => <Loading/>
});
const LoginAsCustomer = Loadable({
    loader: () => import("./components/Mobile/Modules/LoginAsCustomer"),
    loading: () => <Loading/>
});

// /* Scroll Restore */
const ScrollToTop = () => {
    window.scrollTo(0, 0);
    return null;
};

/* React 18 Root */
const container = document.getElementById("root");
const root = createRoot(container);

// const TrackedApp = withTracker(App);


root.render(
    <Root>
        <BrowserRouter>
            <ScrollToTop /> {/* Keep scroll-to-top as a separate component, not a Route */}
            <Routes>
                <Route path="/" element={<App />} />
                <Route path="/search-location" element={withTracker(<Location />)} />
                <Route path="/my-location" element={withTracker(<GeoLocationPage />)} />
                <Route path="/contests" element={withTracker(<Contests />)} />
                <Route path="/events" element={withTracker(<Events />)} />
                <Route path="/event/:id" element={withTracker(<Event />)} />

                <Route path="/categories/stores" element={withTracker(<RestaurantListOnCategory />)} />

                <Route path="/stores/:restaurant" element={withTracker(<ItemsParent />)} />
                <Route path="/stores/:restaurant/:id" element={withTracker(<SingleItemParent />)} />

                <Route path="/explore" element={withTracker(<Explore />)} />

                <Route path="/login" element={withTracker(<Login />)} />
                <Route path="/login/forgot-password" element={withTracker(<ForgotPassword />)} />
                <Route path="/register" element={withTracker(<Register />)} />

                <Route path="/my-account" element={withTracker(<Account />)} />
                <Route path="/alerts" element={withTracker(<Alerts />)} />
                <Route path="/my-addresses" element={withTracker(<Addresses />)} />
                <Route path="/my-wallet" element={withTracker(<WalletPage />)} />
                <Route path="/my-orders" element={withTracker(<Orders />)} />
                <Route path="/rate-order/:id" element={withTracker(<RatingAndReview />)} />
                <Route path="/reviews/:slug" element={withTracker(<ViewStoreReviews />)} />

                <Route path="/checkout" element={withTracker(<Checkout />)} />
                <Route path="/running-order/:unique_order_id" element={withTracker(<RunningOrder />)} />

                <Route path="/cart" element={withTracker(<CartPage />)} />

                <Route path="/pages/:slug" element={withTracker(<SinglePage />)} />
                <Route path="/my-favorite-stores" element={withTracker(<FavoriteRestaurantList />)} />

                {/* Delivery */}
                <Route path="/delivery" element={<Delivery />} />
                <Route path="/delivery/login" element={<DeliveryLogin />} />
                <Route path="/delivery/orders" element={<DeliveryOrders />} />
                <Route path="/delivery/orders/:unique_order_id" element={<ViewOrder />} />
                <Route path="/delivery/completed-orders" element={<Delivery />} />

                {/* Admin login as customer */}
                <Route path="/auth/login-as-customer" element={<LoginAsCustomer />} />
                <Route path="/auth/login-as-customer/:id" element={<LoginAsCustomer />} />

                {/* Catch-all 404 */}
                <Route path="*" element={<NotFound />} />
            </Routes>
        </BrowserRouter>
    </Root>
);